import React, { useLayoutEffect } from "react";

import { matchPath, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import UserHeader from "./UserHeader";
import routes from "../../routes/routes";
import { checkEmptyVal } from "../../utils/common";
import FooterCopyRight from "./FooterCopyRight";
import { ToastView } from "../common/ToastView";

const PublicLayout = ({ children }) => {
  //const { isAuthenticated } = useAuth();

  const path = useLocation();
  const allowedRoutes = ["/m/documents", "/m/invoices"];

  const isMobileRoute = allowedRoutes.some(
    (route) => path.pathname === route || path.pathname.startsWith(route + "/"),
  );
  const hideLayoutRoute = routes.find(
    (route) =>
      route.hideLayout &&
      matchPath({ path: route.path, end: true }, path.pathname),
  );

  useLayoutEffect(() => {
    let animationFrameId;

    const syncHeaderOffset = (resetFixedHeader = false) => {
      const header = document.querySelector("header.nav-on-top");
      const content = header?.nextElementSibling;

      if (!header || !content?.classList.contains("content-wrapper")) return;

      if (resetFixedHeader) header.classList.remove("fixed-top");

      if (window.innerWidth > 991) {
        content.style.marginTop = `${header.getBoundingClientRect().height}px`;
      } else {
        content.style.marginTop = "0px";
      }
    };

    const handleResize = () => syncHeaderOffset(true);

    // ClientAuth has no header. On its SPA transition to Signin, wait until
    // React has committed the newly mounted header before measuring it.
    animationFrameId = window.requestAnimationFrame(() => syncHeaderOffset());
    window.addEventListener("resize", handleResize);

    return () => {
      window.cancelAnimationFrame(animationFrameId);
      window.removeEventListener("resize", handleResize);
    };
  }, [path.pathname]);

  if (isMobileRoute || hideLayoutRoute) {
    return (
      <>
        {hideLayoutRoute ? (
          children
        ) : (
          <div className="bg-light content-wrapper">{children}</div>
        )}
        <ToastView />
      </>
    );
  }

  let routesList = routes.filter((r) => r.isprotected);
  let isprotectedRoute = false;
  let protectedRoutes = ["createprofile"];
  if (
    protectedRoutes.some((route) => path.pathname.toLowerCase().includes(route))
  ) {
    isprotectedRoute = true;
  } else {
    isprotectedRoute = routesList.find((rl) =>
      matchPath({ path: rl.path, end: true }, path.pathname),
    );
  }

  return (
    <>
      {checkEmptyVal(isprotectedRoute) ? (
        <Header></Header>
      ) : (
        <UserHeader></UserHeader>
      )}
      <div className="bg-light content-wrapper">{children}</div>
      {checkEmptyVal(isprotectedRoute) ? (
        <Footer />
      ) : (
        <FooterCopyRight isBorder={false} css="text-center" />
      )}

      <ToastView />
    </>
  );
};

export default PublicLayout;
